import type { IconSvgObject } from './types';

const ShellIcon: IconSvgObject = [
  ["path", { d: "M11.5 12C11.0439 11.3928 10.3179 11 9.49998 11C8.11927 11 6.99998 12.1193 6.99998 13.5C6.99998 14.8807 8.00003 17 10.5 17C13.5 17 15 14.5 15 12.5C15 9.5 12.9999 7 9.49998 7C6.00003 7 3.00003 9.5 3.00003 14C3.00003 17.3137 5.50003 22 12 22C16.9706 22 21.0001 16.9706 21.0001 12C21.0001 7.02944 17.0001 2 12.0001 2C11.4478 2 11.0001 2.44772 11.0001 3V7", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default ShellIcon;
